<template>
    <div >
        <!-- 微电网概况 -->
        <MicrogridOverview @drawElectricLine="drawElectricLine"/>
        <!-- 接线图 -->
        <ViewDiagram  @showDiagram="showDiagram" v-show="isshowDiagram"/>

        <!-- 总览 -->
        <Power />
        <Events @showAlarmPosition="showAlarmPositionBy"/>

        <!-- 微电网 -->
        <PowerGeneration/>
        <Soc />
        <Environmental />

    </div>
</template>

<script>
    const MicrogridOverview = () => import("./components/MicrogridOverview.vue")
    const Power = () => import("./components/Power")
    const Monitor = () => import("../../components/Monitor")
    const Events = () => import("../../components/Events")
    const MenuButton = () => import("../../../components/menuButton/menuButton.vue")
    const PowerGeneration = () => import("./components/PowerGeneration")
    const Soc = () => import("./components/Soc")
    const Environmental = () => import("./components/Environmental")
    const ViewDiagram = () => import("./components/ViewDiagram")


    import {
        GetAlarmList,
    } from "../../../components/Request";
    import DateDiff from "../../../components/DateDiff"

    export default {
        name: "microgrid",
        components: {
            MicrogridOverview,
            Power,
            Monitor,
            Events,
            MenuButton,
            PowerGeneration,
            Soc,
            Environmental,
            ViewDiagram,

        },
        data() {
            return {
                // 底部导航菜单
                menu: -1,

                // 安防类型
                currentType: 0,
                // 安防设备
                currentDetails: 0,

                alarmId: 0,

                // 顶部报警事件
                alarmState: false,
                alarmTime: 'hidden',
                eventsList:[],
                eventsListt:[],

                iframeWin: {},

                timer: null,
                // 显示全屏接线图
                isshowDiagram:false,
            };
        },
        mounted() {
            if(this.$store.state.currentPage == 0){
                this.$store.commit('set_page',1)
            }
            
        },
        beforeDestroy() {
        },
        computed:{
            electricityFlag(){
                return this.$store.state.electricityFlag
            },
            
        },
        watch: {
            alarmTime(n, o) {
                if (n === 'show') {
                    setTimeout(() => {
                        this.alarmTime = 'hidden'
                    }, 1000 * 30)
                }
            },
            alarmState(val){
                if(val == true){
                    setTimeout(() => {
                        this.alarmState = false
                    },5000)
                }
            },
            electricityFlag(val){
                console.log(val);
                if(val == true){
                    this.sendMessage('clearPowerMonitor')
                }
            },
        },
        methods: {
            getAlarmInfo() {
                GetAlarmList({
                    projectId: this.$store.state.projectId,
                    size: 1,
                    page: 1
                }).then(({
                    data
                }) => {
                    let datas = data.data.alarms
                    if (datas.length > 0) {
                        this.alarmState = true
                        if (datas[0].id != this.alarmId) {
                            this.alarmId = datas[0].id
                            this.alarmTime = 'show'
                        }
                        this.alarm.type = ''
                        this.alarm.area = datas[0].area_name
                        this.alarm.text = (datas[0].loop_name || datas[0].device_name) + '-' + datas[0].alarm_type_desc
                        this.alarm.time = DateDiff((new Date(datas[0].start_time)).getTime())
                    } else {
                        this.alarmState = false
                        this.alarmTime = 'hidden'
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            showAlarmPosition() {
                this.menu = 0
                this.iframeWin.postMessage({
                        cmd: "showAlarmPosition",
                        value: this.alarm
                    },
                    "*"
                );
            },
            showAlarmPositionBy(value) {
                this.$store.commit('set_electricityFlag',true)
                this.menu = 0
                let alarm = {
                    area:value.area,
                    text:value.eloop,
                    time:value.etime,
                    type:value.ename,
                    level:value.level
                }
                setTimeout(()=>{
                    this.iframeWin.postMessage({
                        cmd: "showAlarmPosition",
                        value: alarm
                    },"*");
                },100)
                
            },
            showDiagram(flag){
                this.isshowDiagram = flag
            },
            drawElectricLine(flag){
                this.$emit('drawElectricLine',flag)
            }
        },
    };
</script>

<style lang="less" scoped>
    

    .menuButtons{
        width: 10vw;
        height: 7vh;
        position: fixed;
        top: 6.8vh;
        left: 22.5vw;
        display: flex;
        flex-direction: row;
    }

    .posAlarm{
        width: 20.8vw;
        position: fixed;
        top: 8vh;
        border-radius: 4px;
        right: 22vw;
        background: linear-gradient(0deg, rgba(0, 33, 59, 0.8) 0%, rgba(3, 13, 24, 0.8) 100%);
        box-shadow: 
            0 0 16rem 0 #FF5555, 
            0 0 16rem 0 #FF5555;
        padding: 0 5rem;
        .alarmEvents{
            width: 100%;
            padding: 0 15rem;
            max-height: 92vh;
            overflow-x:hidden ;
            overflow-y: scroll;
            &::-webkit-scrollbar{
                width: 4px;
            }
            &::-webkit-scrollbar-thumb{
                background-color: rgba(255, 255, 255, 0.7);
                border-radius: 2rem;
            }
            .alarmEvent{
                height: 7.87vh;
                width: 95%;
                .atop{
                    padding-top: 1.4vh;
                    font-size: 24rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #FFFFFF;
                    position: relative;
                    .img{
                        width: 2.6vh;
                        height: 2.6vh;
                        vertical-align: middle;
                        margin-top: 0.4vh;
                        display: inline-block;
                        background: url('../../../assets/img/r.png') no-repeat;
                        background-size: 100% 100%;
                    }
                    .eventName{
                        display: inline-block;
                        text-shadow: 
                        0 0 1vh  #de5962,
                        0 0 2vh  #de5962,
                        0 0 3vh  #de5962;
                    }
                    span{
                        position: absolute;
                        right: 0;
                        top: 2vh;
                        font-size: 14rem;
                        font-weight: 400;
                        color: rgba(255, 255, 255, 0.7);
                    }
                    img:nth-of-type(1){
                        width: 16rem;
                        height: 16rem;
                        position: absolute;
                        top: 2.1vh;
                        right: -2.7vh;
                    }
                }
                .abottom{
                    font-size: 16rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 0.7);
                    padding-left: 1.3vw;
                    padding-top: 0.2vh;
                    position: relative;
                    .con{
                        width: 14vw; 
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    img{
                        width: 0.7vw;
                        height: 1.7vh;
                        position: absolute;
                        right: 0;
                        top: 0;
                    }
                }
                
            }
            
        }
    }
    .yellowAlarm{
        box-shadow: 
            0 0 16rem 0 #F5AA00, 
            0 0 16rem 0 #F5AA00;  
            .alarmEvents{
                .alarmEvent{
                    .atop{
                        .img{
                            background: url('../../../assets/img/y.png') no-repeat;
                        }
                        .eventName{  
                            text-shadow: 
                                0 0 1vh  #F5AA00,
                                0 0 2vh  #F5AA00,
                                0 0 3vh  #F5AA00;
                        }
                    }
                }
            }
            
    }
    .blueAlarm{
        box-shadow: 
            0 0 16rem 0 #0D94FF, 
            0 0 16rem 0 #0D94FF;
            .alarmEvents{
                .alarmEvent{
                    .atop{
                        .img{
                            background: url('../../../assets/img/b.png') no-repeat;
                        }
                        .eventName{  
                            text-shadow: 
                                0 0 1vh  #0D94FF,
                                0 0 2vh  #0D94FF,
                                0 0 3vh  #0D94FF;
                        }
                    }
                }
            }
    }

    .alarm-enter,
    .alarm-leave-to {
        top: 0,
    }

    .alarm-enter-active,
    .alarm-leave-active {
        transition: top 1s
    }

    .posAlarms{
        width: 20.8vw;
        position: fixed;
        top: 8vh;
        border-radius: 4px;
        right: 22vw;
        background: linear-gradient(0deg, rgba(0, 33, 59, 0.85) 0%, rgba(3, 13, 24, 0.9) 100%);
        padding: 0 5rem;
        .alarmEventss{
            width: 100%;
            padding: 0 15rem;
            max-height: 92vh;
            overflow-x:hidden ;
            overflow-y: scroll;
            &::-webkit-scrollbar{
                width: 4px;
            }
            &::-webkit-scrollbar-thumb{
                background-color: rgba(255, 255, 255, 0.7);
                border-radius: 2rem;
            }
            .alarmEvents{
                height: 7.87vh;
                width: 100%;
                border-bottom: 1px solid rgba(255, 255, 255, 0.3);
                .atops{
                    padding-top: 1.4vh;
                    font-size: 24rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #FFFFFF;
                    position: relative;
                    img{
                        width: 2.6vh;
                        height: 2.6vh;
                        vertical-align: middle;
                    }
                    span{
                        position: absolute;
                        right: 0;
                        top: 2vh;
                        font-size: 14rem;
                        font-weight: 400;
                        color: rgba(255, 255, 255, 0.7);
                    }
                }
                .abottoms{
                    font-size: 16rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 0.7);
                    padding-left: 1.7vw;
                    padding-top: 0.2vh;
                    position: relative;
                    .cons{
                        width: 14vw; 
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    img{
                        width: 0.7vw;
                        height: 1.7vh;
                        position: absolute;
                        right: 0;
                        top: 0;
                    }
                }
            }

            .noneEvent{
                height: 3vh;
                line-height: 3vh;
                font-size: 16rem;
                text-align: center;
                color: #FFFFFF;
            }
        }
    }
</style>